<template src="./printqrcode.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import QrCode from "@/pages/vehicles/qrcode/qrcode.vue";

  export default {
    components: { QrCode },
    data() {
      return {
        ShowLoader: false,
        VehicleId: 0,
        VehicleData: {}
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Vehicle QR Code";
      this.VehicleId = this.$route.params.Id;
      setTimeout(() => {
        this.GetVehicleDetail();
      }, 1000);
    },
    methods: {
      PrintReport() {
        window.print();
      },
      GetVehicleDetail() {
      this.ShowLoader = true;
      Axios.post(Endpoints.Vehicle.Get, {
        token: localStorage.getItem("token"),
        vehicle_id: this.VehicleId,
      }).then((Response) => {
        console.log("GetVehicleDetail Response", Response);
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.VehicleData = Response.data.vehicle;
        }
      });
    },
    },
  };
</script>
<style scoped>
.qr-code-text{
  font-size: 14px;
  font: bold;
}
  @media print {
    .print_btn {
      display: none;
    }
  }
</style>
